import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-alert-danger",
  "use": "rt-base-alert-danger-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-alert-danger\"><path d=\"M512 64.7C265 64.7 64.7 265 64.7 512S265 959.3 512 959.3 959.3 759 959.3 512 759 64.7 512 64.7z m-44 234.4c0-6.2 6.1-11.1 14-11.1h60c7.9 0 14 4.9 14 11.1v226c0 6.2-6.1 11.1-14 11.1h-60c-7.9 0-14-4.9-14-11.1v-226zM512 716c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z\" p-id=\"1714\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/alert-danger.svg
// module id = 1618
// module chunks = 228